export const DRINK_TYPE_COFFEE = "Coffee";
export const DRINK_TYPE_TEA = "Tea";

export const PERIOD_TODAY = "today";
export const PERIOD_YESTERDAY = "yesterday";
export const PERIOD_THIS_WEEK = "thisweek";
export const PERIOD_THIS_MONTH = "thismonth";
